import '../css/CustomerInfo.css'

import { Col, Row, Space } from 'antd'

interface Client {
    check_in_id: string // 入住id
    check_in_user_name: string // 姓名
    check_in_phone: string // 手机号码
    check_in_store_name: string // 入住门店
    preg_status_desc: string // 怀孕时期
    expect_born_day: string // 预产期
    actually_born_day: string // 分娩日
    check_in_time: string // 实际入住日期
    check_out_time_init: string // 预计出所日期
    check_out_time_finally: string // 实际出所日期
    emergency_man_name: string // 紧急联系人
    emergency_phone: string // 紧急联系人手机号
    accompany_man_name: string // 陪护人
    accompany_phone: string // 陪护人手机号
    check_in_total_days: number // 入住总天数
    check_in_already_days: number // 已入住天数
    check_in_left_days: number // 剩余天数
}

interface Prop {
    data?: Client,
    status: string,
    onChange?: () => void
}

export default function (props: Prop) {

    return (<div className="modules">
        {/* 月嫂中心 -> 会所客户管理 -> 客户详情 -> 客户信息 */}
        <div className="top clear" style={{ marginBottom: 20 }}>
            <h3 className="fl">
                <span className="fl">客户信息</span>
                <span className="fl waitstatus">{props.status}</span>
            </h3>
        </div>

        <div className="content" >
            <Row style={{ width: '100%', marginTop: 15 }}>
                <Col span={6} >
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>客人姓名：</p>
                            <p className="right-text">{props.data?.check_in_user_name || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>手机号码：</p>
                            <p className="right-text">{props.data?.check_in_phone || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>怀孕时期：</p>
                            <p className="right-text">{props.data?.preg_status_desc || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>预产期/分娩日：</p>
                            <p className="right-text">{props.data?.expect_born_day} / {props.data?.actually_born_day || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>实际入所日期：</p>
                            <p className="right-text">{props.data?.check_in_time || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>预计出所日期：</p>
                            <p className="right-text">{props.data?.check_out_time_init || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>实际出所日期：</p>
                            <p className="right-text">{props.data?.check_out_time_finally || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>陪护人：</p>
                            <p className="right-text">{props.data?.accompany_man_name || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>陪护人手机：</p>
                            <p className="right-text">{props.data?.accompany_phone || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>紧急联系人：</p>
                            <p className="right-text">{props.data?.emergency_man_name || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>紧急联系人手机：</p>
                            <p className="right-text">{props.data?.emergency_phone || '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={6}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>入住门店：</p>
                            <p className="right-text">{props.data?.check_in_store_name || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>预住总天数：</p>
                            <p className="right-text">{props.data?.check_in_total_days || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>已入住天数：</p>
                            <p className="right-text">{props.data?.check_in_already_days || '--'}</p>
                        </Space>
                    </div>

                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 110, textAlign: 'right' }}>剩余天数：</p>
                            <p className="right-text">{props.data?.check_in_left_days || '--'}</p>
                        </Space>
                    </div>
                </Col>
            </Row>
        </div>
    </div>)
}